// import enquire from 'enquire.js/dist/enquire.min';

/* If nav item with mega menu has an open mega menu, the site-header style should be as if it's fixed. */
const navItemsWithMegaMenus = document.querySelectorAll('.nav__menu-item--has-mega-menu');

const addClassToSiteHeader = navItem => {
    navItem.addEventListener('mouseenter', function () {
        document.querySelector('body').classList.add('js-site-header--fixed');
    }, false);
    navItem.addEventListener('mouseleave', function () {
        document.querySelector('body').classList.remove('js-site-header--fixed');
    }, false);
}
navItemsWithMegaMenus.forEach(addClassToSiteHeader);

// enquire.register('screen and (max-width: 992px)', {
//     match: function () {
//         // code
//     },
//     unmatch: function () {
//         // code
//     },
// });

// import enquire from 'enquire.js/dist/enquire.min';

// // get all sub menus and mega menus in the top level navigation
// var topLinkSubMenus = $('.site-header > .nav__menu-item--has-mega-menu > ul, .site-header > .nav__menu-item--has-mega-menu > div');

// // get all close buttons
// var closeBtns = document.querySelectorAll('.mega-menu__close-btn');
// var topLinkParents = $('.site-header > .nav__menu-item--has-mega-menu');

// // close all dropdowns in the top nav
// function closeAllTopDropDowns() {
//     // close all open dropdowns in the main menu
//     topLinkParents.removeClass('open');
//     $('.site-header').removeClass('js-has-mega-menu-open');
//     topLinkSubMenus.slideUp();
// }

// // listend for a touch and click event on each of them
// for (var i = 0, max = closeBtns.length; i < max; i++) {
//     var btn = closeBtns[i];

//     btn.addEventListener('click', closeAllTopDropDowns);
//     btn.addEventListener('touchstart', closeAllTopDropDowns);
// }

// // control how dropdowns should work on desktop
// function controlDropDownsOnDesktop() {
//     // open mega menu and sub menu hover
//     $('.site-header > .nav__menu-item--has-mega-menu > a')
//         .off('touchstart, click')
//         .on('mouseenter', function () {
//             // var link = this,
//             var linkParent = this.parentElement,
//                 subMenu = linkParent.lastElementChild;

//             // don't close all menus when you hover over an open one top link
//             if (false === linkParent.classList.contains('open')) {
//                 closeAllTopDropDowns();
//             }

//             $(linkParent).addClass('open');
//             $('.site-header').addClass('js-has-mega-menu-open');

//             $(subMenu).slideDown({
//                 start: function () {
//                     $(this).css({
//                         display: 'flex',
//                     });
//                 },
//             });
//         })
//         .on('touchstart, click', function () {
//             // var link = this,
//             var linkParent = this.parentElement,
//                 subMenu = linkParent.lastElementChild;

//             $(linkParent).toggleClass('open');
//             $('.site-header').toggleClass('js-has-mega-menu-open');

//             $(subMenu).slideToggle({
//                 start: function () {
//                     $(this).css({
//                         display: 'flex',
//                     });
//                 },
//             });
//         });

//     // listen for clicks outside the mega menu
//     $('body').on('touchstart, click', function (e) {
//         // stop if the click was on the top menu drop downs
//         if ($(e.target).hasClass('.nav__menu-item--has-mega-menu')) {
//             return;
//         }

//         // stop if the click was on the top menu drop downs children
//         if ($(e.target).closest('.nav__menu-item--has-mega-menu').length) {
//             return;
//         }

//         closeAllTopDropDowns();
//     });

//     // sub-menus in the mega menus
//     $('li[class*="mega-menu-"] .nav__menu-item--has-mega-menu')
//         .off('touchstart, click')
//         .on('mouseenter', function () {
//             var linkParent = this,
//                 subMenu = this.lastElementChild;

//             $(linkParent).addClass('open');
//             $('.site-header').addClass('js-has-drop-down-open');

//             $(subMenu).stop().slideDown();
//         })
//         .on('mouseleave', function () {
//             var linkParent = this,
//                 subMenu = this.lastElementChild;

//             $(linkParent).removeClass('open');
//             $('.site-header').removeClass('js-has-drop-down-open');

//             $(subMenu).stop().slideUp();
//         });
// }

// enquire.register('screen and (max-width: 1199px)', {
//     // OPTIONAL
//     // Triggered once immediately upon registration of handler
//     setup: function () {
//         // on desktop
//         if ($(window).width() >= 1199) {
//             controlDropDownsOnDesktop();
//         }
//     },

//     // REQUIRED
//     // Triggered when the media query transitions
//     // from *unmatched* to *matched*
//     match: function () {
//         // on mobile

//         // hide all expanded top sub manus and mega menues in the header
//         var topDropDowns = $('.site-header > .nav__menu-item--has-mega-menu > ul, .site-header > .nav__menu-item--has-mega-menu > div');

//         topDropDowns.css({
//             display: 'none',
//         });

//         // mega menu hover effect
//         $('.nav__menu-item--has-mega-menu a')
//             .off('touchstart, click, mouseenter, mouseleave')
//             .on('touchstart, click', function (e) {
//                 e.preventDefault;

//                 var link = this,
//                     subMenu = this.nextElementSibling,
//                     linkParent = link.parentNode;

//                 // console.log('touch/click');

//                 $(subMenu).slideToggle();
//                 linkParent.classList.toggle('open');
//             });
//     },

//     // OPTIONAL
//     // Triggered when the media query transitions
//     // from a *matched* to *unmatched*
//     unmatch: function () {
//         // on desktop
//         controlDropDownsOnDesktop();
//     },
// });



// WEBPACK FOOTER //
// ./scripts/routes/other/mega-menu.js